import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "star",
  "use": "star-usage",
  "viewBox": "0 0 18 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 17\" id=\"star\"><path fill=\"#FFC300\" fill-rule=\"evenodd\" d=\"m9 13.5-5.29 2.78 1.01-5.89L.44 6.22l5.91-.86L9 0l2.65 5.36 5.91.86-4.28 4.17 1.01 5.89z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol